import { moveToFulfilled, update } from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import type {
  FeedLoadFulfilledAction,
  FeedLoadNewerThreadsFulfilledAction,
  FeedLoadOlderThreadsFulfilledAction,
} from '../../domains/feedLoad/actions.types';
import type { UserHideUserFulfilledAction } from '../../domains/hideUsers/hideUserActions.types';
import type { UserUnhideUserFulfilledAction } from '../../domains/hideUsers/unhideUserActions.types';
import type { SearchLoadFulfilledAction, SearchLoadMoreFulfilledAction } from '../../domains/searches/actions.types';

import type { UserHideFields } from './types';

export type UserHideFieldAction =
  | FeedLoadFulfilledAction
  | FeedLoadNewerThreadsFulfilledAction
  | FeedLoadOlderThreadsFulfilledAction
  | SearchLoadFulfilledAction
  | SearchLoadMoreFulfilledAction
  | UserHideUserFulfilledAction
  | UserUnhideUserFulfilledAction;

const initialState: UserHideFields = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const reducer: Reducer<UserHideFields, UserHideFieldAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'FEED.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.userHideFields);
    case 'FEED.LOAD_NEWER_THREADS_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.userHideFields);
    case 'FEED.LOAD_OLDER_THREADS_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.userHideFields);
    case 'SEARCH.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.userHideFields);
    case 'SEARCH.LOAD_MORE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.userHideFields);
    case 'USER.HIDE_USER_FULFILLED':
      return update(state, action.payload.userId, { viewerHasHidden: true });
    case 'USER.UNHIDE_USER_FULFILLED':
      return update(state, action.payload.userId, { viewerHasHidden: false });
    default:
      return state;
  }
};

export default reducer;
